import { render, staticRenderFns } from "./IconUsp.vue?vue&type=template&id=cbc15430&scoped=true&"
import script from "./IconUsp.vue?vue&type=script&lang=ts&"
export * from "./IconUsp.vue?vue&type=script&lang=ts&"
import style0 from "./IconUsp.vue?vue&type=style&index=0&id=cbc15430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc15430",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default})
